module.exports = __webpack_public_path__ + "img/order-data.f11672d2.svg";